import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";
import { useTranslation } from "../../hooks/useTranslation";

interface RepresentationStepProps {
  hasAttorney: string;
  onChange: (field: string, value: string) => void;
}

const RepresentationStep: React.FC<RepresentationStepProps> = ({
  hasAttorney,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 2 out of 5
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        2. {t("form.secondQuestion.question")}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={hasAttorney === "NO"}
          onClick={() => onChange("hasAttorney", "NO")}
        >
          {t("form.secondQuestion.option1")}
        </FormButton>

        <FormButton
          isSelected={hasAttorney === "YES"}
          onClick={() => onChange("hasAttorney", "YES")}
        >
          {t("form.secondQuestion.option2")}
        </FormButton>
      </Box>
    </>
  );
};

export default RepresentationStep;
